<scitis-app-global-page-header [pageTitle]="'User administration'">
  <!--USERS COUNT-->
  <ng-template #entryCount>
    <div class="page-header-counts">
      <div class="count">
        <span [innerText]="userCount" class="badge badge-pill badge-primary"></span>
        <span class="count-label" translate>Users</span>
      </div>
    </div>
  </ng-template>

  <!--USERS SEARCH-->
  <ng-template #filterElement>
    <div class="search">
      <input (change)="onSearchForUsers($event)" [(ngModel)]="searchTerm"
             [placeholder]=" ('Search user' | translate) + '...'"
             class="form-control"
             type="search">
    </div>
  </ng-template>

  <!--USERS FILTER-->
  <ng-template #filterElement>
    <div #dropdownFilter="ngbDropdown" [autoClose]="'outside'" class="d-inline-block" ngbDropdown
         placement="bottom-right">
      <button class="btn btn-outline-primary" id="dropdownFilter" ngbDropdownToggle>
        <span [class.d-none]="appliedNumberOfFilters!==0" class="fa-solid fa-filter"></span>
        <span [class.d-none]="appliedNumberOfFilters===0" [innerText]="appliedNumberOfFilters"
              class="badge badge-pill badge-primary badge-round mr-1"></span>
        <span translate>Filter</span>
      </button>
      <div aria-labelledby="dropdownFilter" ngbDropdownMenu>
        <div class="form-group mb-1">
          <label for="selectOrganization" translate>Organization</label>
          <ng-select (change)="onChangeOrganization($event)"
                     (mousedown)="$event.stopPropagation()"
                     [(ngModel)]="selectedOrganizationId"
                     [disabled]="isLoading"
                     [items]="allOrganizations"
                     [placeholder]="'Select organization'|translate"
                     bindLabel="name" bindValue="id"
                     id="selectOrganization"
                     style="width: 220px;">
            <ng-template ng-option-tmp let-item="item">
              <div [title]="item.name" [innerHTML]="item.name" class="dropdown-tooltip-hover-administration"></div>
            </ng-template>
          </ng-select>
        </div>

        <div class="form-group">
          <label for="selectMachineryGroups" translate>Machinery group</label>
          <ng-select (change)="onChangeMachineryGroup($event)"
                     (mousedown)="$event.stopPropagation()"
                     [(ngModel)]="selectedMachineryGroupId"
                     [disabled]="isLoading"
                     [items]="machineryGroupsList"
                     [placeholder]="'Select machinery group'|translate"
                     bindLabel="name"
                     bindValue="id"
                     id="selectMachineryGroups"
                     style="width: 220px;">
            <ng-template ng-option-tmp let-item="item">
              <div [title]="item.name" [innerHTML]="item.name" class="dropdown-tooltip-hover-administration"></div>
            </ng-template>
          </ng-select>
        </div>
        <button (click)="onApplyFilterClick(); dropdownFilter.close();"
                [disabled]="isLoading"
                class="btn btn-primary btn-block"
                translate>Apply filters
        </button>

      </div>
    </div>
  </ng-template>

  <!--USERS ACTIONS-->
  <ng-template #filterElement>
    <div class="d-inline-block" ngbDropdown>
      <button class="btn btn-outline-primary" id="dropdownActions" ngbDropdownToggle>
        <span translate>Actions</span>
      </button>
      <div aria-labelledby="dropdownActions" ngbDropdownMenu>
        <button (click)="onAddUser()"
                [disabled]="(!isAdminRole && !isTechOrSuperAdmin && !isDistributorRole) || restrictUserInteraction"
                ngbDropdownItem>
          <span class="fa-solid fa-plus"></span>
          <span translate>New User</span>
        </button>
        <button (click)="onBanUsers()"
                [disabled]="isLoading || !isTechOrSuperAdmin  || restrictUserInteraction"
                ngbDropdownItem>
          <span class="fa-solid fa-user-lock"></span>
          <span translate>Ban users</span>
        </button>

        <button (click)="onExportUsersInfo()"
                [disabled]="(!isAdminRole && !isTechOrSuperAdmin && !isDistributorRole) || restrictUserInteraction"
                ngbDropdownItem>
          <span class="fa-solid fa-download"></span>
          <span translate>Export info</span>
        </button>
      </div>
    </div>
  </ng-template>

</scitis-app-global-page-header>

<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
        <tr>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="username" style="width:20%">
            <span translate>User name</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="displayName" style="width:20%">
            <span translate>Display name</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="role">
            <span translate>Role</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="parentName">
            <span translate>Organization</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="machineGroupName">
            <span translate>Machinery group</span>
          </th>
          <th (sort)="onColumnSort($event, true)" class="sortable" scope="col" sortable="banned" style="width:80px">
            <span translate>Banned</span>
          </th>
          <th class="text-right" scope="col">
            <span translate>Action</span>
          </th>
        </tr>
        </thead>
        <tbody>

        <tr
          *ngFor="let user of usersList | paginate: paginateSettings"
          [ngClass]="{'table-inactive': user.banned}">
          <td>
            <b>
              <ngb-highlight [result]="user.username" [term]="searchTerm"></ngb-highlight>
            </b>
          </td>
          <td>
            <ngb-highlight [result]="user.displayName" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>

              <span [ngClass]="badgeClassList[user.role]" class="badge text-lowercase">
                <ngb-highlight [result]="user.role.replace('_', ' ')" [term]="searchTerm"></ngb-highlight>
              </span>
          </td>
          <td>
            <ngb-highlight [result]="user.parentName" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="user.machineGroupName" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
              <span [ngClass]="{
                'fa-user-lock text-danger': user.banned,
                'fa-user text-black-50' : !user.banned
              }" class="fa"></span>
          </td>
          <td class="text-right">
            <scitis-admin-user-action (userDeleteEvent)="onDeleteUserSuccess(user)"
                                      (userUpdatedEvent)="onUserUpdated($event)"
                                      [loggedUserIsAdminOrHigher]="isAdminOrHigher"
                                      [loggedUser]="loggedUser"
                                      [restrictUserInteraction]="restrictUserInteraction"
                                      [user]="user">
            </scitis-admin-user-action>
          </td>
        </tr>
        </tbody>
      </table>
      <div *ngIf="usersList.length === 0"
           class="d-flex align-items-center justify-content-center mb-0 mt-3 alert alert-info text-center">
        <em class="fa-solid fa-circle-info mr-2"></em>
        <span translate>No users found for searched term and filters.</span>
      </div>
    </div>
  </div>
</div>

<scitis-ngx-pagination [id]="paginateSettings.id"
                       paginationClass="col"
                       [itemsPerPage]="paginateSettings.itemsPerPage"
                       [itemsPerPageOptions]="itemsPerPageOptions"
                       (itemsPerPageChange)="onItemsPerPageChange($event)"
                       (pageNumberChange)="onLoadPageNumber($event)">
</scitis-ngx-pagination>
